import { PeriodName } from "@/models";
import { useAppDispatch } from "@/store/store";
import { actions } from "@/store/slices/userSettingsSlice";

export interface UserSettingsActions {
    setSelectedYear: (year: number) => void;
    setSelectedPeriod: (period: PeriodName) => void;
    setSelectedOwner: (ownerId: number) => void;
    setSelectedGroup: (groupId: number) => void;
    setSelectedApartment: (apartmentId: number) => void;
    setAggregateMethod: (method: "sum" | "avg") => void;
}

export const useUserSettingsDispatch = (): UserSettingsActions => {
    const dispatch = useAppDispatch();

    const setSelectedYear = (year: number) => {
        dispatch(actions.setSelectedYear(year));
    };

    const setSelectedPeriod = (period: PeriodName) => {
        dispatch(actions.setSelectedPeriod(period));
    };

    const setSelectedOwner = (ownerId: number) => {
        dispatch(actions.setSelectedOwner(ownerId));
    };

    const setSelectedGroup = (groupId: number) => {
        dispatch(actions.setSelectedGroup(groupId));
    };

    const setSelectedApartment = (apartmentId: number) => {
        dispatch(actions.setSelectedApartment(apartmentId));
    };

    const setAggregateMethod = (method: "sum" | "avg") => {
        dispatch(actions.setAggregateMethod(method));
    };

    return {
        setSelectedYear,
        setSelectedPeriod,
        setSelectedOwner,
        setSelectedGroup,
        setSelectedApartment,
        setAggregateMethod,
    };
};
